import React from "react";
import { Row, Col } from "antd";
import BannerIcon from "../../../../assets/seller/icons/topbanner-image.webp";
import { ReactComponent as IndiaFlagLogo } from "../../../../assets/seller/icons/india_flag_full.svg";

const HeroSection = React.memo(({ onPhoneKeyDown }) => (
  <>
    <section className="top-banner-bg d-none d-md-block d-lg-block d-xl-block">
      <div className="banner-section">
        <div className="container top-banner " style={{ margin: "0 auto" }}>
          <Row className="top-banner-section" gutter={[16, 16]} align="middle">
            <Col md={14}>
              <span className="cashflow-button">
                <span className="cashflow-text">CASHFLOW UNLOCKED</span>
              </span>
              <h1 className="top-banner-text">
                Your <span className="text-gradient"> line of credit</span>{" "}
                partner with complete <span className="text-gradient"> sales management</span>
              </h1>
              <p className="top-banner-text-sm mt-2">No payment worries anymore!</p>
              <div style={{ marginTop: "24px" }}>
                <div className="custom-input-register">
                  <div className="form-controll-click text-left d-flex">
                    <input
                      type="tel"
                      id="txtMobileNo"
                      className="form-control position-relative text-banner-mobile"
                      aria-describedby=""
                      maxLength="10"
                      minLength="10"
                      placeholder="Enter your mobile number"
                      pattern="[0-9]*"
                      onKeyDown={onPhoneKeyDown}
                    />
                    <span className="prefix-number">+91</span>
                    <a href="/SellerLogin" target="_blank" rel="noopener noreferrer" className="custom-button-register" id="btnRegister">
                      Register now
                    </a>
                  </div>
                </div>
              </div>
              <div style={{ marginTop: "16px", display: "flex", alignItems: "center" }}>
                <span className="made-india-italics" style={{ marginRight: "8px" }}>
                  Made in India
                </span>
                <IndiaFlagLogo className="india-flag-icon" />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </section>
    <section className="top-banner-bg d-block d-sm-block d-lg-none d-xl-none">
      <div className="banner-section1">
        <div className="container top-banner " style={{ margin: "0 auto" }}>
          <Row className="top-banner-section" gutter={[16, 16]} align="middle">
            <Col span={24}>
              <span className="cashflow-button">
                <span className="cashflow-text">CASHFLOW UNLOCKED</span>
              </span>
              <h1 className="top-banner-text">
                Your <span className="text-gradient"> line of credit</span>{" "}
                partner with complete <span className="text-gradient"> sales management</span>
              </h1>
              <p className="top-banner-text-sm mt-2">No payment worries anymore!</p>
              <div style={{ marginTop: "24px" }}>
                <div className="form-controll-click text-left">
                  <input
                    type="tel"
                    id="txtMobileNo"
                    className="form-control position-relative"
                    aria-describedby=""
                    maxLength="10"
                    minLength="10"
                    placeholder="Enter your mobile number"
                    pattern="[0-9]*"
                    onKeyDown={onPhoneKeyDown}
                  />
                  <span className="prefix-number">+91</span>
                  <a href="/SellerLogin" target="_blank" rel="noopener noreferrer" className="btn btn-primary register-now-btn" id="btnRegister">
                    Register now
                  </a>
                </div>
              </div>
              <div style={{ marginTop: "16px", display: "flex", alignItems: "center" }}>
                <span className="made-india-italics" style={{ marginRight: "8px" }}>
                  Made in India
                </span>
                <IndiaFlagLogo className="india-flag-icon" />
              </div>
            </Col>
            <Col className="p-0" span={24}>
              <img src={BannerIcon} alt="Dashboard and person using mobile" style={{ width: "100%" }} />
            </Col>
          </Row>
        </div>
      </div>
    </section>
  </>
));

export default HeroSection;
